import React from "react";
import {
  Grid,
  Column,
  Button,
  TextInput,
  Dropdown,
  MultiSelect as CarbonMultiSelect
} from "@carbon/react";

export default function PropertyFilters({
  filters,
  dropdownOptions,
  verificationOptionsByTab,
  statusOptionsByTab,
  handleFilterChange,
  clearAllFilters,
  activeTab,
  builderOptions = [],
}) {
  return (
    <div
      style={{
        padding: "1rem",
        backgroundColor: "#f4f4f4",
        borderRadius: "8px",
        marginBottom: "1rem",
        border: "1px solid #e0e0e0",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "1rem",
          gap: "0.5rem",
        }}
      >
        <h4 style={{ margin: 0 }}>
          Filter Properties
        </h4>
      </div>

      <Grid
        style={{
          rowGap: "1rem",
        }}
      >

        {/* Posted Type */}
        <Column lg={3} md={4} sm={4}>
          <CarbonMultiSelect
            titleText="Posted Type"
            items={dropdownOptions.postedTypeOptions}
            itemToString={(i) => i?.text || ""}
            selectedItems={filters.postedType}
            label="Select"
            onChange={({ selectedItems }) =>
              handleFilterChange("postedType", selectedItems)
            }
          />
        </Column>

        {/* Tags */}
        <Column lg={3} md={4} sm={4}>
          <CarbonMultiSelect
            titleText="Tags"
            items={dropdownOptions.tags}
            itemToString={(i) => i?.text || ""}
            selectedItems={filters.tags}
            label="Select"
            onChange={({ selectedItems }) =>
              handleFilterChange("tags", selectedItems)
            }
          />
        </Column>

        {/* Verification Status */}
        <Column lg={3} md={4} sm={4}>
          <CarbonMultiSelect
            titleText="Verification Status"
            items={verificationOptionsByTab}
            itemToString={(i) => i?.text || ""}
            selectedItems={filters.verificationStatus}
            label="Select"
            onChange={({ selectedItems }) =>
              handleFilterChange("verificationStatus", selectedItems)
            }
          />
        </Column>

        {/* Status */}
        <Column lg={3} md={4} sm={4}>
          <CarbonMultiSelect
            titleText="Status"
            items={statusOptionsByTab}
            itemToString={(i) => i?.text || ""}
            selectedItems={filters.status}
            label="Select"
            onChange={({ selectedItems }) =>
              handleFilterChange("status", selectedItems)
            }
          />
        </Column>

                {/* Posted By Builder */}
        <Column lg={3} md={4} sm={4}>
          <Dropdown
            id="filter-posted-by-builder"
            titleText="Posted By"
            label="Select"
            items={builderOptions}
            itemToString={(item) => (item ? item.text : "")}
            selectedItem={
              builderOptions.find(
                (item) => item.id === filters.postedByBuilder
              ) || null
            }
            onChange={({ selectedItem }) =>
              handleFilterChange(
                "postedByBuilder",
                selectedItem ? selectedItem.id : ""
              )
            }
          />
        </Column>

        {/* Created From */}
        <Column lg={2} md={4} sm={4}>
          <TextInput
            type="date"
            labelText="Created From"
            value={filters.createdFrom}
            onChange={(e) =>
              handleFilterChange("createdFrom", e.target.value)
            }
          />
        </Column>

        {/* Created To */}
        <Column lg={2} md={4} sm={4}>
          <TextInput
            type="date"
            labelText="Created To"
            value={filters.createdTo}
            onChange={(e) =>
              handleFilterChange("createdTo", e.target.value)
            }
          />
        </Column>

        {/* Verified Filters */}
        {activeTab === "verified" && (
          <>
            <Column lg={2} md={4} sm={4}>
              <TextInput
                type="date"
                labelText="Verified From"
                value={filters.verifiedFrom}
                onChange={(e) =>
                  handleFilterChange("verifiedFrom", e.target.value)
                }
              />
            </Column>

            <Column lg={2} md={4} sm={4}>
              <TextInput
                type="date"
                labelText="Verified To"
                value={filters.verifiedTo}
                onChange={(e) =>
                  handleFilterChange("verifiedTo", e.target.value)
                }
              />
            </Column>
          </>
        )}

        {/* Price */}
        <Column lg={3} md={4} sm={4}>
<TextInput
  labelText="Price contains"
  placeholder="e.g. 5,000"
  value={filters.priceInfo}
  onChange={(e) => {
    // Allow only digits and commas
    let value = e.target.value.replace(/[^0-9,]/g, "");

    // Remove leading commas (can't start with ,)
    value = value.replace(/^,+/, "");

    // Collapse multiple consecutive commas into one
    value = value.replace(/,{2,}/g, ",");

    handleFilterChange("priceInfo", value);
  }}
/>
        </Column>

        {/* Clear Button */}
        <Column
          lg={2}
          md={4}
          sm={4}
          style={{
            display: "flex",
            alignItems: "flex-end",
            paddingBottom: "0.1rem",
          }}
        >
          <Button
            kind="secondary"
            size="sm"
            onClick={clearAllFilters}
            style={{ width: "100%" }}
          >
            Clear
          </Button>
        </Column>

      </Grid>
    </div>
  );
}